module.exports = __webpack_public_path__ + "img/i2.3defab75.gif";